import React, { useState, useEffect, useRef } from 'react';
import './Navbar.css';
import { redirect, useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config';
import { Button, Link, Typography, FormGroup, FormControlLabel, Checkbox, Select, MenuItem, InputBase, Box, Badge, Divider, IconButton, Avatar, TextField, Chip, ChipGroup } from '@mui/material';
import { PriorityHigh } from '@mui/icons-material';
import { CheckCircle } from '@mui/icons-material';
import { UnfoldMore, NotificationsOutlined as NotificationsIcon, Close, PersonOutlined, SettingsOutlined, Search, ExitToAppOutlined } from '@mui/icons-material';

import axios from 'axios';


const Navbar = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');
    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchLoading, SetSearchLoading] = useState(false);
    const [userInfo, setUserInfo] = useState(true);
    const [permissions, setPermissions] = useState([]);
    const token = localStorage.getItem('token');

    // State to store the selected organization ID
    const [selectedOrgId, setSelectedOrgId] = useState('');
    const [notifications, setNotifications] = useState([
        { id: 1, text: 'New order received' },
        { id: 2, text: 'ONCA1234 has been assigned to you.' }
    ]);
    const [notificationOpen, setNotificationOpen] = useState(false);
    const [notificationMore, setNotificationMore] = useState(false);
    const [userMenuOpen, setUserMenuOpen] = useState(false);

    const [searchResultsOpen, setSearchResultsOpen] = useState(false);

    const [currentOrdersChecked, setCurrentOrdersChecked] = useState(false);
    const [finishedOrdersChecked, setFinishedOrdersChecked] = useState(false);
    const [doNotProceedChecked, setDoNotProceedChecked] = useState(false);
    const [recentlyDeletedChecked, setRecentlyDeletedChecked] = useState(false);
    const [urgentOnly, setUrgentOnly] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const notificationRef = useRef(null);

    const handleClickOutside = (event) => {
        if (notificationRef.current && !notificationRef.current.contains(event.target)) {
            setNotificationOpen(false);
        }
    };

    useEffect(() => {
        if (notificationOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [notificationOpen]);



    useEffect(() => {
        fetchUserInfo();
    }, []);

    useEffect(() => {
        const fetchOrganizations = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/org/all-user-org`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch organizations');
                }

                const data = await response.json();

                setOrganizations(data);

                const savedOrgId = localStorage.getItem('selectedOrg');

                if (savedOrgId) {
                    setSelectedOrgId(savedOrgId);
                } else if (data.length > 0) {
                    setSelectedOrgId(data[0].orgId);
                    localStorage.setItem('selectedOrg', data[0].orgId);
                    window.location.reload();
                }
            } catch (error) {
                console.error('Error fetching organizations:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchOrganizations();
    }, [token]);

    useEffect(() => {
        fetchUserPermissions();
    }, [token, selectedOrgId]);

    const fetchUserLatestMessages = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/users/latest-messages`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error('Failed to fetch user latest messages');
            }

            const data = await response.json();
            setNotificationMore(false);

            setNotifications(data);

        } catch (error) {
            console.error('Error fetching user latest messages:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // Fetch initial notifications on page load
        if (!notificationMore) {
            fetchUserLatestMessages();
        }
        
        // Set up periodic refresh only if notificationMore is false
        let interval;

        // Recent messages: refresh every 10 secs
        if (!notificationMore) {
            interval = setInterval(() => {
                fetchUserLatestMessages();
            }, 10000);
        }

        // All messages: refresh every 60 secs
        if (notificationMore) {
            interval = setInterval(() => {
                handleLoadAllMessages();
            }, 60000);
        }
        
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [notificationMore]);

    const handleLoadAllMessages = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/users/all-messages`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });
            
            if (!response.ok) throw new Error('Failed to fetch all messages');
            setNotificationMore(true);
            
            const data = await response.json();
            setNotifications(data);
        } catch (error) {
            console.error('Error loading all messages:', error);
        }
    };



    // Search function
    const handleSearch = async () => { // todo
        if (!searchTerm.trim()) {
        setSearchResults([]);
        return;
        }
        SetSearchLoading(true);
        try {
            const response = await axios.get(`${API_BASE_URL}/orders/search`, {
                params: {
                keyword: searchTerm,
                currentOrders: currentOrdersChecked,
                finishedOrders: finishedOrdersChecked,
                doNotProceed: doNotProceedChecked,
                recentlyDeleted: recentlyDeletedChecked,
                urgentOnly: urgentOnly,
                orgId: selectedOrgId,
                user: userInfo.email,
                },
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                    SelectedOrg: selectedOrgId,
                },
            });
            setSearchResults(response.data);
        } catch (error) {
        console.error('Search error:', error);
        setSearchResults([]);
        } finally {
            SetSearchLoading(false);
        }
    };

    // Effect to trigger search
    useEffect(() => {
        const timer = setTimeout(() => {
        if (searchTerm) {
            handleSearch();
        }
        }, 500); // Debounce delay

        return () => clearTimeout(timer);
    }, [searchTerm, currentOrdersChecked, finishedOrdersChecked, doNotProceedChecked, recentlyDeletedChecked, urgentOnly]);


    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };

    const handleOrgChange = (event) => {
        const selectedOrgId = event.target.value;
        setSelectedOrgId(selectedOrgId);
        
        if (selectedOrgId) {
            localStorage.setItem('selectedOrg', selectedOrgId);
            window.location.reload();
        } else {
            localStorage.removeItem('selectedOrg');
        }
    
        navigate('/dashboard');
    };

    const handleDeleteNotification = (id) => {
        setNotifications(prev => prev.filter(n => n.id !== id));
    };

    const fetchUserInfo = async () => {
        const token = localStorage.getItem('token');
        if (!token) {
            handleLogout();
            return;
        }
        try {
            const response = await axios.get(`${API_BASE_URL}/profile/info`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setUserInfo(response.data);

            if (response.data.firstName && response.data.lastName) {
                localStorage.setItem('userName', `${response.data.firstName} ${response.data.lastName}`);
            }
            if (response.data.email) {
                localStorage.setItem('userEmail', response.data.email);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                handleLogout();
            } else {
                console.error('Error fetching user info:', error);
            }
        }
    };

    const fetchUserPermissions = async () => {
        const MAX_RETRIES = 5;
        const RETRY_DELAY = 1000;
        
        for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
            const token = localStorage.getItem('token');
            const orgId = localStorage.getItem('selectedOrg');
            
            if (token && orgId) {
                // Existing permission fetching logic
                try {
        
                    const response = await axios.get(`${API_BASE_URL}/org/all-permissions`, {
                        headers: { Authorization: `Bearer ${token}` },
                        params: { selectedOrg: orgId },
                    });
                    if (response.data != null) {
                        setPermissions(response.data);
                        setCurrentOrdersChecked(response.data.current_order_read === 1);
                        setFinishedOrdersChecked(response.data.finished_order_read === 1);
                        setDoNotProceedChecked(response.data.do_not_proceed_read === 1);
                        setRecentlyDeletedChecked(response.data.recently_deleted_read === 1);
                        return;
                    }
                
                } catch (error) {
                    console.error('Error fetching permissions:', error);
                    handleLogout();
                    return
                }
            }
            
            if (attempt < MAX_RETRIES) {
                await new Promise(resolve => setTimeout(resolve, RETRY_DELAY));
            }
        }
        
        // If we get here, we've exhausted all retries without success
        handleLogout();
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('selectedOrg');
        navigate('/');
    };

    const handleOrderNavigation = (type, orderId) => {
        window.open(`/#/${type}/${orderId}`, '_blank');
        setSearchResultsOpen(false);
        setSearchResults([]);
    };
    
    return (
        <nav className="navbar" style={{ 
            backgroundColor: '#fff',
            borderRadius: '0',
            height: '64px',
            borderBottom: '1px solid #e0e0e0',
        }}>
            <div className="navbarBrand">
                <Select
                    value={selectedOrgId}
                    onChange={handleOrgChange}
                    variant="filled"
                    disableUnderline
                    IconComponent={UnfoldMore}
                    sx={{
                        width: 240,
                        height: '64px',
                        bgcolor: '#ffffff',
                        borderRadius: '0',
                        borderRight: '1px solid #e0e0e0',
                        borderBottom: '1px solid #e0e0e0',
                        '& .MuiSelect-select': {
                            py: 1.5,
                            px: 2,
                            color: '#333',
                            fontSize: '0.875rem',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        },
                        '& .MuiSvgIcon-root': {
                            color: '#666',
                            right: 8
                        }
                    }}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                mt: 0,
                                borderRadius: '0 0 10px 10px',
                                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                '& .MuiMenuItem-root': {
                                    color: '#333',
                                    fontSize: '0.875rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    '&:hover': {
                                        bgcolor: '#f5f5f5'
                                    },
                                    '&.Mui-selected': {
                                        bgcolor: '#e0e0e0'
                                    }
                                },
                                left: '0 !important',
                            }
                        }
                    }}
                >
                    {loading ? (
                        <MenuItem disabled sx={{ color: 'text.secondary' }}>
                            Loading organizations...
                        </MenuItem>
                    ) : organizations.length > 0 ? (
                        organizations.map(org => (
                            <MenuItem key={org.orgId} value={org.orgId} sx={{ height: 64 }}>
                                <img 
                                    src={`${API_BASE_URL}/org/get-org-logo/${org.orgId}`}
                                    alt=""
                                    style={{
                                        width: 64,
                                        maxHeight: 64,
                                        borderRadius: '4px',
                                        objectFit: 'cover',
                                        marginRight: '0px'
                                    }}
                                />
                                <span style={{ 
                                    maxWidth: '120px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                }}>
                                    <b>{org.orgName}</b>
                                </span>
                            </MenuItem>
                        ))
                    ) : (
                        <MenuItem disabled>No Organization Found</MenuItem>
                    )}
                </Select>
            </div>
            { /* Search */}
            <div className="search-container" style={{ 
                flexGrow: 1,
                position: 'relative',
                margin: '0 0px',
                height: '64px',
                alignSelf: 'center',
                borderBottom: '1px solid #eee'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    height: '64px',
                    borderRadius: '0px',
                    padding: '0 0px',
                    backgroundColor: '#fff',
                    position: 'relative'
                }}>
                    <input
                        type="text"
                        placeholder=" Search..."
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setSearchResultsOpen(!!e.target.value);
                        }}
                        onKeyPress={handleKeyPress}
                        style={{
                            flex: 1,
                            border: 'none',
                            outline: 'none',
                            background: 'transparent',
                            padding: '0 32px 0 8px',
                            fontSize: '18px',
                            height: '64px',
                            minWidth: '100vw',
                        }}
                    />
                    {searchTerm && (
                        <IconButton 
                            size="small"
                            onClick={() => {
                                setSearchTerm('');
                                setSearchResultsOpen(false);
                            }}
                            sx={{
                                position: 'absolute',
                                right: '24px',
                                padding: '4px',
                                backgroundColor: 'rgba(0,0,0,0.04)',
                                '&:hover': {
                                    backgroundColor: 'rgba(0,0,0,0.08)'
                                }
                            }}
                        >
                            <Close fontSize="small" sx={{ color: '#666' }} />
                        </IconButton>
                    )}
                </div>

                {searchResultsOpen && (
                    <div style={{
                        position: 'absolute',
                        top: '64px',
                        left: 0,
                        right: 0,
                        backgroundColor: '#fff',
                        border: '1px solid #e0e0e0',
                        borderRadius: '0 0 10px 10px',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                        zIndex: 9999,
                        padding: '20px',
                        maxHeight: '75vh',
                        overflowY: 'auto'
                    }}>
                        {/* Floating Filter Bar */}
                        <div style={{
                            position: 'sticky',
                            top: -20,
                            backgroundColor: '#ffffff',
                            zIndex: 100,
                            padding: '16px',
                            margin: '-20px -20px 20px -20px',
                            borderBottom: '1px solid #f0f0f0',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.04)'
                        }}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                marginBottom: '12px'
                            }}>
                                <span style={{
                                    fontWeight: 700,
                                    fontSize: '0.9rem',
                                    color: '#424242',
                                    letterSpacing: '0.5px',
                                    textTransform: 'uppercase'
                                }}>
                                    Filter Results
                                </span>
                                <span style={{
                                    fontSize: '0.75rem',
                                    color: '#666',
                                    fontWeight: 400
                                }}>
                                    {searchResults.length} orders found
                                </span>
                            </div>
                            
                            <Box sx={{ 
                                display: 'flex', 
                                flexWrap: 'wrap',
                                gap: 1,
                                alignItems: 'center'
                            }}>
                                <Chip
                                    label="Current Orders"
                                    onClick={() => setCurrentOrdersChecked(!currentOrdersChecked)}
                                    onDelete={currentOrdersChecked ? () => setCurrentOrdersChecked(false) : undefined}
                                    deleteIcon=<CheckCircle fontSize="small" />
                                    color={currentOrdersChecked ? "primary" : "default"}
                                    variant={currentOrdersChecked ? "filled" : "outlined"}
                                    disabled={permissions.current_order_read === 0}
                                    sx={{
                                        borderRadius: '16px',
                                        fontWeight: 500,
                                        '&.MuiChip-filledPrimary': {
                                            backgroundColor: '#1976d2',
                                            color: '#fff'
                                        },
                                        '&.MuiChip-outlinedPrimary': {
                                            borderColor: '#1976d2',
                                            color: '#1976d2'
                                        }
                                    }}
                                />
                                
                                <Chip
                                    label="Finished Orders"
                                    onClick={() => setFinishedOrdersChecked(!finishedOrdersChecked)}
                                    onDelete={finishedOrdersChecked ? () => setFinishedOrdersChecked(false) : undefined}
                                    deleteIcon=<CheckCircle fontSize="small" />
                                    color={finishedOrdersChecked ? "success" : "default"}
                                    variant={finishedOrdersChecked ? "filled" : "outlined"}
                                    disabled={permissions.finished_order_read === 0}
                                    sx={{
                                        borderRadius: '16px',
                                        fontWeight: 500,
                                        '&.MuiChip-filledSuccess': {
                                            backgroundColor: '#4caf50',
                                            color: '#fff'
                                        },
                                        '&.MuiChip-outlinedSuccess': {
                                            borderColor: '#4caf50',
                                            color: '#4caf50'
                                        }
                                    }}
                                />
                                
                                <Chip
                                    label="Do Not Proceed"
                                    onClick={() => setDoNotProceedChecked(!doNotProceedChecked)}
                                    onDelete={doNotProceedChecked ? () => setDoNotProceedChecked(false) : undefined}
                                    deleteIcon=<CheckCircle fontSize="small" />
                                    color={doNotProceedChecked ? "error" : "default"}
                                    variant={doNotProceedChecked ? "filled" : "outlined"}
                                    disabled={permissions.do_not_proceed_read === 0}
                                    sx={{
                                        borderRadius: '16px',
                                        fontWeight: 500,
                                        '&.MuiChip-filledError': {
                                            backgroundColor: '#f44336',
                                            color: '#fff'
                                        },
                                        '&.MuiChip-outlinedError': {
                                            borderColor: '#f44336',
                                            color: '#f44336'
                                        }
                                    }}
                                />
                                
                                <Chip
                                    label="Recently Deleted"
                                    onClick={() => setRecentlyDeletedChecked(!recentlyDeletedChecked)}
                                    onDelete={recentlyDeletedChecked ? () => setRecentlyDeletedChecked(false) : undefined}
                                    deleteIcon=<CheckCircle fontSize="small" />
                                    color={recentlyDeletedChecked ? "default" : "default"}
                                    variant={recentlyDeletedChecked ? "filled" : "outlined"}
                                    disabled={permissions.recently_deleted_read === 0}
                                    sx={{
                                        borderRadius: '16px',
                                        fontWeight: 500,
                                        backgroundColor: recentlyDeletedChecked ? '#9e9e9e' : 'transparent',
                                        color: recentlyDeletedChecked ? '#fff' : '#666',
                                        borderColor: '#9e9e9e',
                                        '&:hover': {
                                            backgroundColor: recentlyDeletedChecked ? '#757575' : 'rgba(158, 158, 158, 0.08)'
                                        }
                                    }}
                                />
                                
                                <Chip
                                    label="Urgent Only"
                                    onClick={() => setUrgentOnly(!urgentOnly)}
                                    onDelete={urgentOnly ? () => setUrgentOnly(false) : undefined}
                                    deleteIcon=<PriorityHigh fontSize="small" />
                                    color={urgentOnly ? "warning" : "default"}
                                    variant={urgentOnly ? "filled" : "outlined"}
                                    sx={{
                                        borderRadius: '16px',
                                        fontWeight: 500,
                                        '&.MuiChip-filledWarning': {
                                            backgroundColor: '#ff9800',
                                            color: '#fff'
                                        },
                                        '&.MuiChip-outlinedWarning': {
                                            borderColor: '#ff9800',
                                            color: '#ff9800'
                                        }
                                    }}
                                />
                            </Box>
                        </div>
                        {searchResults.length === 0 && !searchLoading && (
                            <div style={{
                                padding: '16px',
                                textAlign: 'center',
                                color: '#666',
                                fontStyle: 'italic'
                            }}>
                                No matching orders found
                            </div>
                        )}
                        {searchResults.length === 0 && searchLoading && (
                            <div style={{
                                padding: '16px',
                                textAlign: 'center',
                                color: '#666',
                                fontStyle: 'italic'
                            }}>
                                Loading ...
                            </div>
                        )}
                        {/* Current Orders Section */}
                        {searchResults.filter(order => 
                            order.jobs.some(job => !job.do_not_proceed && !job.completed && !job.deleted)
                        ).length > 0 && (
                            <div>
                                <div style={{
                                    padding: '12px 16px',
                                    borderLeft: '4px solid #1976d2',
                                    backgroundColor: '#f8f9fa',
                                    marginBottom: '12px',
                                    borderRadius: '4px 0 0 4px',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                                }}>
                                    <span style={{
                                        fontWeight: 700,
                                        fontSize: '0.9rem',
                                        color: '#1976d2',
                                        letterSpacing: '0.5px',
                                        textTransform: 'uppercase'
                                    }}>
                                        Current Orders
                                    </span>
                                </div>
                                
                                {searchResults.filter(order => 
                                    order.jobs.some(job => !job.do_not_proceed && !job.completed && !job.deleted)
                                ).map(order => {
                                    const activeJobs = order.jobs.filter(job => !job.do_not_proceed && !job.completed && !job.deleted);
                                    const urgentJobs = activeJobs.filter(job => job.urgent);
                                    
                                    return (
                                        <div 
                                            key={`current-${order.order_id}`}
                                            onClick={() => handleOrderNavigation('order', order.order_id)}
                                            style={{
                                                marginBottom: '16px',
                                                cursor: 'pointer',
                                                padding: '16px',
                                                borderRadius: '8px',
                                                border: '1px solid #e0e0e0',
                                                backgroundColor: '#ffffff',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                                                transition: 'all 0.2s ease',
                                                '&:hover': { 
                                                    backgroundColor: '#f8f9fa',
                                                    boxShadow: '0 4px 8px rgba(0,0,0,0.08)',
                                                    transform: 'translateY(-1px)'
                                                }
                                            }}
                                        >
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between',
                                                alignItems: 'flex-start',
                                                marginBottom: '12px'
                                            }}>
                                                <div>
                                                    <div style={{ 
                                                        fontWeight: 700, 
                                                        color: '#1a1a1a', 
                                                        fontSize: '1rem',
                                                        marginBottom: '4px'
                                                    }}>
                                                        {order.prefix}{order.order_name}
                                                    </div>
                                                    <div style={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center',
                                                        gap: '8px',
                                                        fontSize: '0.95rem',
                                                        fontWeight: 600,
                                                        color: '#1a1a1a'
                                                    }}>
                                                        <span style={{ fontWeight: 700, color: '#1976d2' }}>
                                                            {order.customer_name}
                                                        </span>
                                                        {order.company_name && (
                                                            <>
                                                                <span style={{ color: '#999' }}>•</span>
                                                                <span style={{ fontWeight: 700, color: '#388e3c' }}>
                                                                    {order.company_name}
                                                                </span>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            {activeJobs.length > 0 && (
                                                <div style={{ 
                                                    marginTop: '12px',
                                                    paddingTop: '12px',
                                                    borderTop: '1px solid #f0f0f0'
                                                }}>
                                                    <ul style={{ 
                                                        margin: 0,
                                                        paddingLeft: '0',
                                                        listStyleType: 'none'
                                                    }}>
                                                        {activeJobs.map(job => (
                                                            <li 
                                                                key={job.job_id}
                                                                style={{
                                                                    color: job.urgent ? '#e65100' : '#424242',
                                                                    marginBottom: '6px',
                                                                    padding: '8px 12px',
                                                                    borderRadius: '2px',
                                                                    backgroundColor: job.urgent ? '#fff3e0' : '#f5f5f5',
                                                                    borderLeft: job.urgent ? '4px solid #ff9800' : '4px solid #bdbdbd',
                                                                    fontSize: '0.85rem',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    transition: 'all 0.2s ease'
                                                                }}
                                                            >
                                                                <span style={{ fontWeight: 500 }}>
                                                                    {job.job_name}
                                                                </span>
                                                                <span style={{
                                                                    color: job.urgent ? '#ff9800' : '#757575',
                                                                    fontSize: '0.8rem',
                                                                    fontWeight: 400,
                                                                    backgroundColor: job.urgent ? 'rgba(255, 152, 0, 0.1)' : 'rgba(117, 117, 117, 0.1)',
                                                                    padding: '2px 8px',
                                                                    borderRadius: '2px',
                                                                    border: job.urgent ? '1px solid rgba(255, 152, 0, 0.3)' : '1px solid rgba(117, 117, 117, 0.3)'
                                                                }}>
                                                                    {job.step_name}
                                                                </span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {/* Finished Orders */}
                        {searchResults.filter(order => 
                            order.jobs.some(job => job.completed && !job.deleted)
                        ).length > 0 && (
                            <div>
                                <div style={{
                                    padding: '12px 16px',
                                    borderLeft: '4px solid #4caf50',
                                    backgroundColor: '#f8f9fa',
                                    marginBottom: '12px',
                                    borderRadius: '4px 0 0 4px',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                                }}>
                                    <span style={{
                                        fontWeight: 700,
                                        fontSize: '0.9rem',
                                        color: '#4caf50',
                                        letterSpacing: '0.5px',
                                        textTransform: 'uppercase'
                                    }}>
                                        Finished Orders
                                    </span>
                                </div>
                                
                                {searchResults.filter(order => 
                                    order.jobs.some(job => job.completed && !job.deleted)
                                ).map(order => {
                                    const completedJobs = order.jobs.filter(job => job.completed && !job.deleted);
                                    
                                    return (
                                        <div 
                                            key={`finished-${order.order_id}`}
                                            onClick={() => handleOrderNavigation('order/finished-order', order.order_id)}
                                            style={{
                                                marginBottom: '16px',
                                                cursor: 'pointer',
                                                padding: '16px',
                                                borderRadius: '8px',
                                                border: '1px solid #e0e0e0',
                                                backgroundColor: '#ffffff',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                                                transition: 'all 0.2s ease',
                                                '\u0026:hover': { 
                                                    backgroundColor: '#f8f9fa',
                                                    boxShadow: '0 4px 8px rgba(0,0,0,0.08)',
                                                    transform: 'translateY(-1px)'
                                                }
                                            }}
                                        >
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between',
                                                alignItems: 'flex-start',
                                                marginBottom: '12px'
                                            }}>
                                                <div>
                                                    <div style={{ 
                                                        fontWeight: 700, 
                                                        color: '#1a1a1a', 
                                                        fontSize: '1rem',
                                                        marginBottom: '4px'
                                                    }}>
                                                        {order.prefix}{order.order_name}
                                                    </div>
                                                    <div style={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center',
                                                        gap: '8px',
                                                        fontSize: '0.95rem',
                                                        fontWeight: 600,
                                                        color: '#1a1a1a'
                                                    }}>
                                                        <span style={{ fontWeight: 700, color: '#1976d2' }}>
                                                            {order.customer_name}
                                                        </span>
                                                        {order.company_name && (
                                                            <>
                                                                <span style={{ color: '#999' }}>•</span>
                                                                <span style={{ fontWeight: 700, color: '#388e3c' }}>
                                                                    {order.company_name}
                                                                </span>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {completedJobs.length > 0 && (
                                                <div style={{ 
                                                    marginTop: '12px',
                                                    paddingTop: '12px',
                                                    borderTop: '1px solid #f0f0f0'
                                                }}>
                                                    <ul style={{ 
                                                        margin: 0, 
                                                        paddingLeft: '0',
                                                        listStyleType: 'none'
                                                    }}>
                                                        {completedJobs.map(job => (
                                                            <li 
                                                                key={job.job_id}
                                                                style={{
                                                                    color: '#4caf50',
                                                                    marginBottom: '6px',
                                                                    padding: '8px 12px',
                                                                    borderRadius: '2px',
                                                                    backgroundColor: '#f1f8e9',
                                                                    borderLeft: '4px solid #4caf50',
                                                                    fontSize: '0.85rem',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    transition: 'all 0.2s ease'
                                                                }}
                                                            >
                                                                <span style={{ fontWeight: 500 }}>
                                                                    {job.job_name}
                                                                </span>
                                                                <span style={{
                                                                    color: '#4caf50',
                                                                    fontSize: '0.8rem',
                                                                    fontWeight: 400,
                                                                    backgroundColor: 'rgba(76, 175, 80, 0.1)',
                                                                    padding: '2px 8px',
                                                                    borderRadius: '2px',
                                                                    border: '1px solid rgba(76, 175, 80, 0.3)'
                                                                }}>
                                                                    {job.step_name}
                                                                </span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {/* Do Not Proceed Orders */}
                        {searchResults.filter(order => 
                            order.jobs.some(job => job.do_not_proceed && !job.deleted)
                        ).length > 0 && (
                            <div>
                                <div style={{
                                    padding: '12px 16px',
                                    borderLeft: '4px solid #f44336',
                                    backgroundColor: '#f8f9fa',
                                    marginBottom: '12px',
                                    borderRadius: '4px 0 0 4px',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                                }}>
                                    <span style={{
                                        fontWeight: 700,
                                        fontSize: '0.9rem',
                                        color: '#f44336',
                                        letterSpacing: '0.5px',
                                        textTransform: 'uppercase'
                                    }}>
                                        Do Not Proceed Orders
                                    </span>
                                </div>
                                
                                {searchResults.filter(order => 
                                    order.jobs.some(job => job.do_not_proceed && !job.deleted)
                                ).map(order => {
                                    const dnpJobs = order.jobs.filter(job => job.do_not_proceed && !job.deleted);
                                    
                                    return (
                                        <div 
                                            key={`dnp-${order.order_id}`}
                                            onClick={() => handleOrderNavigation('order/do-not-proceed', order.order_id)}
                                            style={{
                                                marginBottom: '16px',
                                                cursor: 'pointer',
                                                padding: '16px',
                                                borderRadius: '8px',
                                                border: '1px solid #e0e0e0',
                                                backgroundColor: '#ffffff',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                                                transition: 'all 0.2s ease',
                                                '\u0026:hover': { 
                                                    backgroundColor: '#f8f9fa',
                                                    boxShadow: '0 4px 8px rgba(0,0,0,0.08)',
                                                    transform: 'translateY(-1px)'
                                                }
                                            }}
                                        >
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between',
                                                alignItems: 'flex-start',
                                                marginBottom: '12px'
                                            }}>
                                                <div>
                                                    <div style={{ 
                                                        fontWeight: 700, 
                                                        color: '#1a1a1a', 
                                                        fontSize: '1rem',
                                                        marginBottom: '4px'
                                                    }}>
                                                        {order.prefix}{order.order_name}
                                                    </div>
                                                    <div style={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center',
                                                        gap: '8px',
                                                        fontSize: '0.95rem',
                                                        fontWeight: 600,
                                                        color: '#1a1a1a'
                                                    }}>
                                                        <span style={{ fontWeight: 700, color: '#1976d2' }}>
                                                            {order.customer_name}
                                                        </span>
                                                        {order.company_name && (
                                                            <>
                                                                <span style={{ color: '#999' }}>•</span>
                                                                <span style={{ fontWeight: 700, color: '#388e3c' }}>
                                                                    {order.company_name}
                                                                </span>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {dnpJobs.length > 0 && (
                                                <div style={{ 
                                                    marginTop: '12px',
                                                    paddingTop: '12px',
                                                    borderTop: '1px solid #f0f0f0'
                                                }}>
                                                    <ul style={{ 
                                                        margin: 0, 
                                                        paddingLeft: '0',
                                                        listStyleType: 'none'
                                                    }}>
                                                        {dnpJobs.map(job => (
                                                            <li 
                                                                key={job.job_id}
                                                                style={{
                                                                    color: '#f44336',
                                                                    marginBottom: '6px',
                                                                    padding: '8px 12px',
                                                                    borderRadius: '2px',
                                                                    backgroundColor: '#ffebee',
                                                                    borderLeft: '4px solid #f44336',
                                                                    fontSize: '0.85rem',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    transition: 'all 0.2s ease'
                                                                }}
                                                            >
                                                                <span style={{ fontWeight: 500 }}>
                                                                    {job.job_name}
                                                                </span>
                                                                <span style={{
                                                                    color: '#f44336',
                                                                    fontSize: '0.8rem',
                                                                    fontWeight: 400,
                                                                    backgroundColor: 'rgba(244, 67, 54, 0.1)',
                                                                    padding: '2px 8px',
                                                                    borderRadius: '2px',
                                                                    border: '1px solid rgba(244, 67, 54, 0.3)'
                                                                }}>
                                                                    {job.step_name}
                                                                </span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {/* Recently Deleted Orders */}
                        {searchResults.filter(order => 
                            order.jobs.some(job => job.deleted)
                        ).length > 0 && (
                            <div>
                                <div style={{
                                    padding: '12px 16px',
                                    borderLeft: '4px solid #9e9e9e',
                                    backgroundColor: '#f8f9fa',
                                    marginBottom: '12px',
                                    borderRadius: '4px 0 0 4px',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
                                }}>
                                    <span style={{
                                        fontWeight: 700,
                                        fontSize: '0.9rem',
                                        color: '#9e9e9e',
                                        letterSpacing: '0.5px',
                                        textTransform: 'uppercase'
                                    }}>
                                        Recently Deleted Orders
                                    </span>
                                </div>
                                {searchResults.filter(order => 
                                    order.jobs.some(job => job.deleted)
                                ).map(order => {
                                    const deletedJobs = order.jobs.filter(job => job.deleted);
                                    
                                    return (
                                        <div 
                                            key={`deleted-${order.order_id}`}
                                            onClick={() => handleOrderNavigation('order/recently-deleted', order.order_id)}
                                            style={{
                                                marginBottom: '16px',
                                                cursor: 'pointer',
                                                padding: '16px',
                                                borderRadius: '8px',
                                                border: '1px solid #e0e0e0',
                                                backgroundColor: '#ffffff',
                                                boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
                                                transition: 'all 0.2s ease',
                                                opacity: 0.7,
                                                '\u0026:hover': { 
                                                    backgroundColor: '#f8f9fa',
                                                    boxShadow: '0 4px 8px rgba(0,0,0,0.08)',
                                                    transform: 'translateY(-1px)',
                                                    opacity: 0.9
                                                }
                                            }}
                                        >
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between',
                                                alignItems: 'flex-start',
                                                marginBottom: '12px'
                                            }}>
                                                <div>
                                                    <div style={{ 
                                                        fontWeight: 700, 
                                                        color: '#1a1a1a', 
                                                        fontSize: '1rem',
                                                        marginBottom: '4px'
                                                    }}>
                                                        {order.prefix}{order.order_name}
                                                    </div>
                                                    <div style={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center',
                                                        gap: '8px',
                                                        fontSize: '0.95rem',
                                                        fontWeight: 600,
                                                        color: '#1a1a1a'
                                                    }}>
                                                        <span style={{ fontWeight: 700, color: '#1976d2' }}>
                                                            {order.customer_name}
                                                        </span>
                                                        {order.company_name && (
                                                            <>
                                                                <span style={{ color: '#999' }}>•</span>
                                                                <span style={{ fontWeight: 700, color: '#388e3c' }}>
                                                                    {order.company_name}
                                                                </span>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {deletedJobs.length > 0 && (
                                                <div style={{ 
                                                    marginTop: '12px',
                                                    paddingTop: '12px',
                                                    borderTop: '1px solid #f0f0f0'
                                                }}>
                                                    <ul style={{ 
                                                        margin: 0, 
                                                        paddingLeft: '0',
                                                        listStyleType: 'none'
                                                    }}>
                                                        {deletedJobs.map(job => (
                                                            <li 
                                                                key={job.job_id}
                                                                style={{
                                                                    color: '#9e9e9e',
                                                                    marginBottom: '6px',
                                                                    padding: '8px 12px',
                                                                    borderRadius: '2px',
                                                                    backgroundColor: '#f5f5f5',
                                                                    borderLeft: '4px solid #9e9e9e',
                                                                    fontSize: '0.85rem',
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    transition: 'all 0.2s ease'
                                                                }}
                                                            >
                                                                <span style={{ fontWeight: 500 }}>
                                                                    {job.job_name}
                                                                </span>
                                                                <span style={{
                                                                    color: '#9e9e9e',
                                                                    fontSize: '0.8rem',
                                                                    fontWeight: 400,
                                                                    backgroundColor: 'rgba(158, 158, 158, 0.1)',
                                                                    padding: '2px 8px',
                                                                    borderRadius: '2px',
                                                                    border: '1px solid rgba(158, 158, 158, 0.3)'
                                                                }}>
                                                                    {job.step_name}
                                                                </span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                    )}
                </div>
            {/* Notification & User */}
            <div style={{ 
                display: 'flex', 
                alignItems: 'centers', 
                gap: '16px', 
                marginLeft: 'auto',
                borderLeft: '1px solid #eee',
                borderBottom: '1px solid #eee',
                // width: '320px'
            }}>
                
                {/* Notification dropdown */}
                {/*
                <Badge 
                    badgeContent={notifications.length > 9 ? '9+' : notifications.length}
                    overlap="circular"
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    sx={{
                        '& .MuiBadge-badge': {
                            backgroundColor: '#1976d2',
                            color: 'white',
                            top: 10,
                            right: 10,
                            minWidth: '20px',
                            height: '20px',
                            fontSize: '0.75rem'
                        }
                    }}
                >
                    <IconButton onMouseEnter={() => setNotificationOpen(true)} onClick={() => setNotificationOpen(false)}>
                        <NotificationsIcon sx={{ 
                            color: '#666',
                            fontSize: '30px'
                        }}/>
                    </IconButton>
                </Badge>
                */}
                <Select
                    value={userInfo ? 'user-preview' : ''}
                    displayEmpty
                    disableUnderline
                    variant="filled"
                    IconComponent={UnfoldMore}
                    renderValue={() => (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {userInfo?.photo ? (
                                <img 
                                    src={`${API_BASE_URL}/profile/photo/${userInfo.photo}`}
                                    alt="Profile"
                                    style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: '50%',
                                        objectFit: 'cover'
                                    }}
                                />
                            ) : (
                                <Box sx={{ 
                                    width: 40,
                                    height: 40,
                                    bgcolor: '#1976d2',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    fontSize: '1rem'
                                }}>
                                    {userInfo?.firstName?.charAt(0)}{userInfo?.lastName?.charAt(0)}
                                </Box>
                            )}
                            <div style={{ lineHeight: 1.2 }}>
                                <div style={{ color: '#333' }}><b>{userInfo?.firstName || 'Unknown'} {userInfo?.lastName || 'User'}</b></div>
                                <div style={{ fontSize: '0.75rem', color: '#666' }}>
                                    {userInfo?.email || 'unknown@user.com'}
                                </div>
                            </div>
                        </div>
                    )}
                    sx={{
                        height: '64px',
                        minWidth: 240,
                        bgcolor: '#ffffff',
                        '& .MuiSelect-select': {
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            py: 1.5,
                            px: 2,
                            color: '#333',
                            fontSize: '0.875rem'
                        }
                    }}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                mt: 0,
                                borderRadius: '0',
                                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                width: '240px',
                                '& .MuiMenuItem-root': {
                                    gap: '12px',
                                    padding: '8px 16px',
                                    '&:hover': { bgcolor: '#f5f5f5' }
                                }
                            }
                        }
                    }}
                >
                    <MenuItem onClick={() => navigate('/profile')}>
                        <PersonOutlined/>
                        Profile
                    </MenuItem>
                    {
                        /*
                         * <MenuItem onClick={handleSettings}>
                                <SettingsOutlined/>
                                Settings
                            </MenuItem>
                         */
                    }
                    
                    <Divider sx={{ my: 1 }}/>
                    <MenuItem onClick={handleLogout}>
                        <ExitToAppOutlined/>
                        Sign Out
                    </MenuItem>
                </Select>
            </div>

            {/* Notification dropdown */}
            {/*
                Mouse hover over to open, click to close
            */}
            {notificationOpen && (
                <Box 
                    ref={notificationRef}
                    sx={{ 
                        position: 'absolute',
                        right: 20,
                        top: '64px',
                        bgcolor: 'white',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                        width: '300px',
                        zIndex: 9999,
                        borderRadius: '10px',
                        maxHeight: 'calc(100vh - 100px)',
                        overflowY: 'auto'
                    }}
                >
                    {notifications.length === 0 ? (
                        <div style={{
                            padding: '16px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            borderBottom: '1px solid #eee',
                            backgroundColor: '#fff'
                        }}>
                            <div style={{ 
                                color: '#333',
                                fontSize: '0.875rem'
                            }}>
                                No new notifications
                            </div>
                        </div>
                    ) : (
                        notifications.map(notification => (
                            <div key={notification.id} style={{
                                padding: '16px',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                borderBottom: '1px solid #eee',
                                backgroundColor: '#fff'
                            }}>
                                <div>
                                    <div style={{ 
                                        fontSize: '0.75rem',
                                        color: '#666',
                                        marginBottom: '4px'
                                    }}>
                                        {new Date(notification.sent_at).toLocaleString()}
                                    </div>
                                    <div style={{ 
                                        color: '#333',
                                        fontSize: '0.875rem'
                                    }}>
                                        {notification.message}
                                    </div>
                                </div>
                                <IconButton 
                                    size="small"
                                    onClick={() => handleDeleteNotification(notification.id)}
                                    sx={{ color: '#666' }}
                                >
                                    <Close fontSize="small"/>
                                </IconButton>
                            </div>
                        ))
                    )}
                    {notifications.length > 0 && (
                        <div style={{ padding: '8px', textAlign: 'center' }}>
                            <Button 
                                variant="text" 
                                size="small"
                                onClick={() => {
                                    if (notificationMore) {
                                        fetchUserLatestMessages();
                                    } else {
                                        handleLoadAllMessages();
                                    }
                                    setNotificationMore(!notificationMore);
                                }}
                                sx={{ color: '#1976d2' }}
                            >
                                {notificationMore ? 'Show Less' : 'Show More'}
                            </Button>
                        </div>
                    )}
                </Box>
            )}
        </nav>
    );
};

export default Navbar;
